import classNames from 'classnames';
import React from 'react';

type ContentWrapperProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  id?: string;
  className?: string;
};

const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  style,
  id,
  className,
}) => (
  <div
    id={id}
    className={classNames('omtur-content-wrapper', className)}
    style={style}
  >
    {children}
  </div>
);

export default ContentWrapper;
